import { forwardRef, ReactNode, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { CalDays, CalNav, Container, Day, DayContainer, DayHeader, NavBtn, NavTitle, TopTitle } from './GuardianCalendar.styled';
import DatePicker, { registerLocale } from 'react-datepicker';
import { da } from 'date-fns/locale/da';
import { enGB as en } from 'date-fns/locale/en-GB';
import { useDetectClickOutside } from 'react-detect-click-outside';
import Chevron_Icon from "@assets/svg/chevron-down.svg";
import Modal from '@components/Buttons/Modal';
import { ChildContainer, ChildInfo, HeadLine, ImageContainer, LessonItem, LessonList, PillContainer, PopClose, PopCol, PopContainer, PopItem, PopListContent, PopRow, PopSubTitle, PopTitle, TagPill, TnfoText } from '../Guardian.styled';
import StudentThumbnail from '@components/StudentThumbnail';
import Clock_Icon from "@assets/svg/match/late.svg";
import Attendance_Icon from "@assets/svg/match/attending.svg";
import Calendar_Icon from "@assets/svg/new_calendar.svg";
import Close_Icon from "@assets/svg/match/missing.svg";
import Plus_Icon from "@assets/svg/chevron-down.svg";
import moment from 'moment';
import 'moment/locale/de'
import 'moment/locale/es'
import 'moment/locale/nl'
import 'moment/locale/fi'
import 'moment/locale/sv'
import 'moment/locale/nb'
import 'moment/locale/fr'
import 'moment/locale/it'
import 'moment/locale/pt'
import 'moment/locale/tr'
import 'moment/locale/is'
import toTitleCase from '@utils/textTools';
import db from '@utils/db';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import { useStore } from "@store/appStore";
import CardInfo from '@components/GridCards/CardInfo';

registerLocale('da', da);
registerLocale('en-GB', en);


interface IProps {
  loading?:boolean,
  studentId?:string,
  username?:string,
  displayname?:string
}

export const GuardianCalendar = forwardRef((props: IProps, ref) => {
  const { systemSettings } = useStore()
  const [modal, setModal] = useState(false)
  const modalRef = useRef(null);
  const [selectedMonth, setSelectedMonth] = useState<any>({ month: moment().month(), year: moment().year() })
  const i18n = useI18n();
  const [selectedDate, setSelectedDate] = useState(null);
  const [activitiesForDate, setActivitiesForDate] = useState([])
  const [alltags, setAlltags] = useState([])
  const [loading, setLoading] = useState(true)
  const [showAll, setShowAll] = useState(false)
  const [data, setData] = useState(null)

  useImperativeHandle(ref, () => ({
        update() {
            getdata()
        },
    }));

  const getdata = async () => {
    let month = moment(selectedMonth.year + "-" + ((selectedMonth.month + 1) < 10 ? "0" + (selectedMonth.month + 1) : selectedMonth.month + 1) + "-01")
    let firstDayOfMonth = moment(month).startOf('month');
    let lastDayOfMonth = moment(month).endOf('month');
    let data = await db.Student_Stat_GetDayviewRegistrations(props.studentId  , firstDayOfMonth.format("YYYY-MM-DD"), lastDayOfMonth.format("YYYY-MM-DD"));
    setData(data)
  }

  useEffect(() => {
    getdata();
  }, [selectedMonth.month, selectedMonth.year, props.studentId])

  function getDaysInMonth(month: number, year: number) {
    let firstDayOfMonth = moment(`${year}-${month + 1}`, "YYYY-MM").startOf('month');
    let dayNumber = firstDayOfMonth.isoWeekday()
    let daysInMonth = moment(`${year}-${month + 1}`, "YYYY-MM").daysInMonth();
    let days = [];
    for (let i = 1; i < dayNumber; i++) {
      days.push(<Day key={i + "emptyday"}></Day>)
    }


    for (let day = 1; day <= daysInMonth; day++) {
      let exists = data?.filter((item) => {
        let itemDate = new Date(item.lessondate);
        return itemDate.getDate() === day && itemDate.getMonth() === month && itemDate.getFullYear() === year;
      });

      let absencetype = 0;

      for (let index = 0; index < exists?.length; index++) {                
        if(exists[index].absencetype != absencetype && absencetype != 0){
          absencetype = 4
        }
        else if(absencetype === 0){
          absencetype = exists[index].absencetype
        }        
      }
      days.push(<Day key={"day" + day} onClick={exists?() => OpenModal(year + "-" + (month + 1 < 10 ? "0" + (month + 1) : month + 1) + "-" + (day < 10 ? "0" + day : day)):null} active={absencetype}><span>{day}</span></Day>)
    }
    return days
  }


  useEffect(() => { 
      getAllTags()
    }, []);
  
    const getAllTags = async () => {
      let allTags = await db.getAllNote_Tags();
      setAlltags(allTags)
    }

  const changeMonth = (direction: string) => {
    let newMonth = selectedMonth.month;
    let newYear = selectedMonth.year;
    if (direction === 'next') {
      let now = new Date();
      if (now.getFullYear() > newYear || (now.getFullYear() === newYear && now.getMonth() >= newMonth + 1)) {
        newMonth++;
        if (newMonth > 11) {
          newMonth = 0;
          newYear++;
        }
      }
    } else {
      newMonth--;
      if (newMonth < 0) {
        newMonth = 11;
        newYear--;
      }
    }
    setSelectedMonth({ month: newMonth, year: newYear });
  }

  const getLanguage = () => {
    if (i18n.language === 'no') return 'nb'
    else if (i18n.language === 'se') return 'sv'
    else return i18n.language
  }

  const getMonthHeader = (month: number, year: number) => {    
    return toTitleCase(moment(year + "-" + (month + 1 < 10 ? "0" + (month + 1) : month + 1) + "-01").locale(getLanguage()).format('MMMM YYYY'))
  }

  const OpenModal = async (date) => {
    await getActivitiesForDate(date);
    setSelectedDate(date);
    setModal(true)
  }

  const closeModal = () => {    
    setSelectedDate(null);
    setModal(false);
  }

  const getModalHeader = () => {
    if (!selectedDate) return "";
    return toTitleCase(moment(selectedDate).locale(getLanguage()).format('D. MMMM YYYY'))
  }

    const getTags = (tags, absence_id, absencetype) => {      
        let t = []
        if (tags) {
          if (tags === null || tags.length < 0) return [];
          let ids = tags.split(',');
          for (let i = 0; i < ids.length; i++) {
            let tempTag = alltags.find((t) => t.tag_id == ids[i]);
            if (tempTag) {
              t.push(<TagPill big={true} key={absence_id + "_tag_" + tempTag.tag_id} PColor={"#" + tempTag.html_color}>{i18n.t("tag-" + tempTag.name)}</TagPill>)
            }
            else if (ids[i] == "99") t.push(<TagPill big={true} key={absence_id + "_tag_" + absencetype} PColor={"#FED425"}>{i18n.t('tag-Late')}</TagPill>)
          }
        }
        return t
      }

      const getDateTime = (start, end) => {
        let datetimestring = start.substring(0, 5) + " - " + end.substring(0, 5);
        return datetimestring;
      }


      const getTimeSpan = (timeblocks) => {
        let starttime;
        let endtime;
        if(timeblocks.length == 0) return "";
        for (let index = 0; index < timeblocks.length; index++) {
            let start = moment(timeblocks[index].date.substring(0,10) + "t" + timeblocks[index].starttime);
            let end = moment(timeblocks[index].date.substring(0,10) + "t" + timeblocks[index].endtime);
            if(!starttime || start.isBefore(starttime)) starttime = start;
            if(!endtime || end.isAfter(endtime)) endtime = end;
        }
        return starttime.format("HH:mm") + " - " + endtime.format("HH:mm");
      }

  const GetTypeIcon = (type:number) =>{
    if(type === 1 || type === -1){
      return <Attendance_Icon />
    } else if(type === 2){
      return <Close_Icon />
    } else if(type === 3){
      return <Clock_Icon />
    }
  }

  const getActivitiesForDate = async (date) => {
    let timezone = systemSettings.find((s) => s.APP_Setting_ID === 7);
    let i = await db.GetAbsenceRegistrations4Day(props.studentId, date, timezone.value);    
    // let usedAbsenceIds = [];    
    let items = [];
    if (i?.length > 0) {
        items.push(<PopItem key={"activity_" + date}>
          <PopRow>
            <ChildContainer>
              <div>
                <ImageContainer>
                  <StudentThumbnail name={props.displayname} src={props.username} />
                </ImageContainer>
                
              </div>
              <ChildInfo>
                  <span>{props.displayname}</span>
                </ChildInfo>
            </ChildContainer>
          </PopRow>
          <PopRow>
            <PopSubTitle icon={true} expand={showAll}>{i18n.t("guardian-lesson")}<Calendar_Icon />{i.length > 4?<div onClick={() => setShowAll(prev => !prev)}><Plus_Icon /></div>:null}</PopSubTitle>
            <LessonList>
              {i
              .slice(0, showAll ? undefined : 4)
              .map((t, index) => (
                <LessonItem key={"timeblock_" + index}>
                  <div>
                    {GetTypeIcon(t.absence_type)}
                    <div>
                      <div>
                        <b>{getDateTime(t.starttime, t.endtime)}</b> 
                        <b>{t.course_name}</b>
                      </div>
                      <div>
                        {t.course_description}
                      </div>
                    </div>
                    
                  </div>
                  <PillContainer>
                    {getTags(i[0].tag_ids, i[0].absence_id, i[0].absencetype)}              
                  </PillContainer>
                </LessonItem>
              ))}
            </LessonList>
          </PopRow>
        </PopItem>);      
      setActivitiesForDate(items);
    }
  } 
    
  
  return (<>
    {modal ? <Modal ref={modalRef} onClose={closeModal} backColor='rgba(0,0,0,0.25)' stickBottom={true}>
      <PopContainer>
        <PopTitle>{getModalHeader()}</PopTitle>
        <PopClose onClick={() => modalRef.current.handleClose()}><Close_Icon /></PopClose>
        <HeadLine />
        <PopListContent>
          {activitiesForDate.length > 0 ? activitiesForDate : activitiesForDate}        
        </PopListContent>
      </PopContainer>
    </Modal> : null}

    <Container>
      <TopTitle>
        {i18n.t("calendar")}
      </TopTitle>
      <CardInfo padding={true} text={"info-text-cal"}/>
      {!props.loading?
      <>
        <CalNav>
          <NavBtn onClick={() => changeMonth("prev")}><Chevron_Icon /></NavBtn>
          <NavTitle>{getMonthHeader(selectedMonth.month, selectedMonth.year)}</NavTitle>
          <NavBtn onClick={() => changeMonth("next")}><Chevron_Icon /></NavBtn>
        </CalNav>
        <CalDays>
        <DayHeader>
          <span>{moment().locale(getLanguage()).startOf('week').isoWeekday(1).format('dddd').substring(0, 1).toUpperCase()}</span>
          <span>{moment().locale(getLanguage()).startOf('week').isoWeekday(2).format('dddd').substring(0, 1).toUpperCase()}</span>
          <span>{moment().locale(getLanguage()).startOf('week').isoWeekday(3).format('dddd').substring(0, 1).toUpperCase()}</span>
          <span>{moment().locale(getLanguage()).startOf('week').isoWeekday(4).format('dddd').substring(0, 1).toUpperCase()}</span>
          <span>{moment().locale(getLanguage()).startOf('week').isoWeekday(5).format('dddd').substring(0, 1).toUpperCase()}</span>
          <span>{moment().locale(getLanguage()).startOf('week').isoWeekday(6).format('dddd').substring(0, 1).toUpperCase()}</span>
          <span>{moment().locale(getLanguage()).startOf('week').isoWeekday(0).format('dddd').substring(0, 1).toUpperCase()}</span>
        </DayHeader>
        <DayContainer>
          {getDaysInMonth(selectedMonth.month, selectedMonth.year)}
        </DayContainer>
      </CalDays>
      </>
      :
      <RainbowLoader />}
      
    </Container>
  </>);
});

export default GuardianCalendar;
